import { atom } from "recoil";

type modalInfo = {
  isOpen: boolean;
};

export const registModalInfoState = atom<modalInfo>({
  key: "registModalInfoState",
  default: {
    isOpen: false,
  }
});